<template>
	<div class="b-container">
		<div class="content">
			<div class="form-box">
				<div class="item">
					<span class="required">*</span
					><input
						class="common-input"
						type="text"
						:placeholder="baseInfo.titleTips"
						maxlength="72"
						v-model="form.title"
						style="text-align: left"
					/>
				</div>
			</div>

			<div class="form-box">
				<div class="item">
					<span class="label">{{ $t('调研时间') }}<span class="required ml6">*</span></span>
					<div class="item-content" @click="openCalendar()">
						<span class="item-value">{{ formatTmplTime(form.startTime) }}</span>
						<span class="icon-font iconjiantouyou"></span>
					</div>
				</div>
				<div v-if="baseInfo.addressList" class="item">
					<span class="label">{{ $t('调研地址') }}<span class="required ml6">*</span></span>
					<div class="item-content" @click="openAddressPopup">
						<span v-if="form.address" class="item-value">{{ form.address }}</span>
						<span v-else class="item-value item-placeholder">{{ $t('请选择调研地址') }}</span>
						<span class="icon-font iconjiantouyou"></span>
					</div>
				</div>
			</div>

			<div class="add-box">
				<span>{{ $t('调研人员') }}</span>
				<div class="add-btn" @click="gotoEntourage">
					<div class="add-pre-icon">
						<m-svg-icon name="add_fill" class="pre-icon-fill" />
						<m-svg-icon name="add_white" class="pre-icon-white" />
					</div>
					<span>{{ $t('新增随行人员') }}</span>
					<span v-if="entouragePeople.length">({{ entouragePeople.length }})</span>
				</div>
			</div>

			<div class="form-box">
				<div class="upload-box" v-if="baseInfo.businessCardConfig != 3">
					<div style="flex: 1">
						<div class="upload-title">
							{{ $t('上传名片') }} <span class="required" v-if="baseInfo.businessCardConfig == 1">*</span>
						</div>
						<div class="upload-tip">{{ baseInfo.businessCardTips }}</div>
					</div>
					<CBusinessCardUp
						ref="businessCardUpload"
						class="business-card-wrap"
						@onUpload="uploadBusinessCard"
					/>
				</div>

				<div class="item" v-if="baseInfo.nameConfig != 3">
					<span class="label">{{ $t('姓名') }}<span class="required ml6">*</span></span>
					<input class="common-input" v-model="form.userName" type="text" :placeholder="baseInfo.nameTips" />
				</div>
				<div class="item" v-if="baseInfo.institutionConfig != 3">
					<cSearchPicker
						externalClass="c-search"
						:externalValue="form.institutionName"
						inputType="textarea"
						:placeholder="baseInfo.institutionTips"
						@select="inputCompany"
						@input="inputCompany"
					>
						<template>
							<span class="label"
								>{{ $t('所属机构')
								}}<span class="required ml6" v-if="baseInfo.institutionConfig == 1">*</span></span
							>
						</template>
					</cSearchPicker>
				</div>
				<div class="item" v-if="baseInfo.positionConfig != 3">
					<span class="label"
						>{{ $t('职位') }}<span class="required ml6" v-if="baseInfo.positionConfig == 1">*</span></span
					>
					<input
						class="common-input"
						v-model="form.occupation"
						type="text"
						:placeholder="baseInfo.positionTips"
					/>
				</div>
				<div class="item">
					<span class="label">{{ $t('联系方式') }}<span class="required ml6">*</span></span>
					<div class="common-flex">
						<div class="area-input" @click="showAreaCodePicker = true">
							<span class="area-code">+{{ landAreaCode }}</span>
							<i class="icon-font drop-popup">&#xe68e;</i>
							<span class="area-separator"></span>
						</div>
						<van-field
							v-model="form.phoneNumber"
							:placeholder="baseInfo.phoneTips"
							maxlength="11"
							type="tel"
							@input="validateNumber"
							class="clear-van-field"
						/>
					</div>
				</div>
				<div class="item" v-if="baseInfo.emailConfig != 3">
					<span class="label"
						>{{ $t('电子邮箱') }}<span class="required ml6" v-if="baseInfo.emailConfig == 1">*</span></span
					>
					<input class="common-input" v-model="form.email" type="text" :placeholder="baseInfo.emailTips" />
				</div>

				<!-- 自定义类字段 -->
				<template v-if="baseInfo.attendanceCustomFiled">
					<CustomField
						v-for="(item, index) in baseInfo.attendanceCustomFiled"
						:key="index"
						v-show="item.config != 3"
						:field="item"
						:index="index"
						@update="handleCustomFieldUpdate"
					/>
				</template>
			</div>

			<template v-if="baseInfo.commitmentAttachmentConfig != 3">
				<div class="add-box">
					<span>{{ $t('承诺书签署') }}</span>
				</div>
				<div class="form-box">
					<div class="item pd0">
						<span class="label"
							>{{ $t('手写签字')
							}}<span class="required ml6" v-if="baseInfo.commitmentAttachmentConfig == 1">*</span></span
						>
						<div class="signature-preview" @click.stop="setSignature">
							<img v-if="signBase64" :src="signBase64" class="signature-img" />
							<p v-else class="signature-text">{{ $t('添加签字') }}</p>
						</div>
					</div>
					<div class="item">
						<div>
							<div class="common-select-wrap" @click="switchAgree">
								<m-svg-icon
									:class="['common-select', isAgree ? 'common-selected' : '']"
									:name="isAgree ? 'result_success' : 'unselect'"
								/>
							</div>
							<span class="tip">{{ $t('签名即代表您已阅读并同意') }}</span>
							<span
								class="commitments"
								@click.stop="readPromise(item.url)"
								v-for="(item, index) in form.commitmentAttachment"
								:key="item.url"
								>{{ item.name }}{{ index != form.commitmentAttachment.length - 1 ? '、' : '' }}</span
							>
						</div>
					</div>
				</div>
			</template>
		</div>

		<div class="footer" :class="isHuaweiBrowser ? 'HuaweiBrowser' : ''">
			<button :class="['btn', 'font-family-pf-r', disabled ? 'disabled' : '']" @click="handleSubmit">
				{{ $t('提交') }}
			</button>
		</div>

		<AppointmentCalendarPicker
			:visible.sync="calendarVisible"
			:conferenceTemplateId="baseInfo.id"
			:initTime="form.startTime"
			@confirm="confirmTime"
		></AppointmentCalendarPicker>

		<CAddressSelect
			:visible.sync="visibleAddress"
			:addressList="baseInfo.addressList"
			:actionAddress="form.address"
			@onSelect="selectAddress"
		/>

		<m-areacode
			:defaultCode="landAreaCode"
			:visible.sync="showAreaCodePicker"
			@confirm="onAreaCodeConfirm"
		></m-areacode>

		<m-sign :showSign="showSign" :closeFun="() => (showSign = false)" @rewrite="rewriteSign"></m-sign>
	</div>
</template>

<script setup>
import { ref, computed, watch, onMounted, getCurrentInstance, onActivated } from 'vue';
import { useStore, useRouter, useRoute } from '@/utils/vue-api';
import { debounce, dateFormat, getUserInfo } from '@/utils/api';
import AppointmentCalendarPicker from './AppointmentCalendarPicker.vue';
import mSign from '@/components/m-sign';
import cSearchPicker from '@/view/investor_appointment/components/c-search-picker';
import CAddressSelect from '@rebuild/components/form/CAddressSelect.vue';
import CBusinessCardUp from '@rebuild/components/form/CBusinessCardUp.vue';
import CustomField from './custom-fields/index.vue';
import { cloneDeep } from 'lodash-es';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useNavigation } from '@/view/enterprise_rebuild/hooks/useNavigation';
import { Field as VanField } from 'vant';
import dayjs from 'dayjs';

const DEFAULT_NUMBER_CODE = '86';
const { proxy } = getCurrentInstance();
// Router & Store
const router = useRouter();
const route = useRoute();
const store = useStore();

// Refs
const businessCardUpload = ref(null);

// State
const storeId = ref(route.query.storeId || '');
const type = ref(3); // 3-预约调研
const isHuaweiBrowser = ref(false);
const version = ref('0.0.1'); // 缓存版号, 用于后续控制缓存强刷

const baseInfo = ref({});
const form = ref({});

const calendarVisible = ref(false);
const visibleAddress = ref(false);

const showAreaCodePicker = ref(false);
const landAreaCode = ref(DEFAULT_NUMBER_CODE); // 座机国际代码

const showSign = ref(false);
const isAgree = ref(false);

const entouragePeople = ref([]);

onActivated(() => {
	// 随行人员回填
	let string = sessionStorage.getItem('ENTOURAGE');
	const entourageInfoParamList = string ? JSON.parse(string) : [];
	entouragePeople.value = entourageInfoParamList;
});

// Computed
const signBase64 = computed(() => store.state.signBase64);

const disabled = computed(() => {
	const {
		nameConfig,
		institutionConfig,
		positionConfig,
		phoneConfig,
		emailConfig,
		commitmentAttachmentConfig,
		businessCardConfig,
		addressList
	} = baseInfo.value;

	const {
		title,
		userName,
		institutionName,
		occupation,
		phoneNumber,
		email,
		signPath,
		attendanceCustomFiled,
		startTime,
		cardInfo,
		address
	} = form.value;

	const requiredFields = [
		{ value: userName, config: nameConfig },
		{ value: institutionName, config: institutionConfig },
		{ value: occupation, config: positionConfig },
		{ value: phoneNumber, config: phoneConfig },
		{ value: email, config: emailConfig },
		{ value: signPath, config: commitmentAttachmentConfig },
		{ value: isAgree.value, config: commitmentAttachmentConfig },
		{ value: cardInfo, config: businessCardConfig },
		{ value: address, config: addressList }
	];

	// 检查必填字段是否为空且对应配置为 1
	const isAnyFieldInvalid = requiredFields.some(({ value, config }) => !value && config == 1);

	// 检查自定义字段验证（支持所有类型）
	const isCustomFieldInvalid = attendanceCustomFiled?.some(item => {
		if (item.config != 1) return false; // 非必填跳过

		// type=5 (文件)需要特殊处理，检查JSON数组
		if (item.type === 5) {
			try {
				const files = item.dynamicFieldValue ? JSON.parse(item.dynamicFieldValue) : [];
				return files.length === 0;
			} catch {
				return true;
			}
		}

		// 其他类型检查是否有值
		return !item.dynamicFieldValue;
	});

	const areBasicFieldsInvalid = !startTime || !title;

	return isAnyFieldInvalid || isCustomFieldInvalid || areBasicFieldsInvalid;
});

// Watch
watch(
	signBase64,
	val => {
		form.value = { ...form.value, signPath: val };
	},
	{ immediate: true }
);

// Methods (converted from filters)
const formatTmplTime = date => {
	return date ? dateFormat(new Date(Number(date)), 'yyyy/MM/dd') : '';
};

const validateNumber = val => {
	// 通过正则表达式验证，只保留数字
	forceUpdateFormData('phoneNumber', val.replace(/\D/g, ''));
};

// 自定义字段更新处理
const handleCustomFieldUpdate = ({ index, value }) => {
	if (form.value.attendanceCustomFiled && form.value.attendanceCustomFiled[index]) {
		const updatedFields = cloneDeep(form.value.attendanceCustomFiled);
		updatedFields[index].dynamicFieldValue = value;
		forceUpdateFormData('attendanceCustomFiled', updatedFields);
	}
};

// Methods
const showDialog = options => {
	store.dispatch('showDialog', options);
};

const { appointment_surveyInfo, appointment_applySurveyRecord } = useModuleData();

const loadSurveyOption = async () => {
	await appointment_surveyInfo.refresh({ type: type.value });
	const { commitments, commitmentAttachmentConfig, attendanceCustomFiled } = appointment_surveyInfo.data?.data || {};

	const additionOption = {};
	if (commitmentAttachmentConfig !== 3) {
		additionOption.commitmentAttachment = commitments;
	}
	if (attendanceCustomFiled && attendanceCustomFiled.length) {
		const copiedFields = cloneDeep(attendanceCustomFiled);
		additionOption.attendanceCustomFiled = copiedFields;
		additionOption.customFiledConfig = copiedFields;
	}

	form.value = {
		...form.value,
		...additionOption
	};
	baseInfo.value = appointment_surveyInfo.data?.data || {};
};

const forceUpdateFormData = (key, value) => {
	proxy.$set(form.value, key, value);
};

// 调研时间
const openCalendar = () => {
	calendarVisible.value = true;
};

const confirmTime = ({ time }) => {
	forceUpdateFormData('startTime', time);
};

// 调研地址
const openAddressPopup = () => {
	visibleAddress.value = true;
};

const selectAddress = debounce(function (val) {
	forceUpdateFormData('address', val);
});

const onAreaCodeConfirm = code => {
	console.log('🚀 ~ onAreaCodeConfirm ~ code:', code);
	landAreaCode.value = code;
};

const syncAreaValue = data => {
	landAreaCode.value = data.areaCode ? data.areaCode.slice(1) : DEFAULT_NUMBER_CODE;
};

const gotoEntourage = () => {
	router.push({
		name: 'investor_entourage',
		query: {
			phone: form.value.phoneNumber || '',
			conferenceTemplateId: baseInfo.value.id,
			storeId: storeId.value,
			scene: 'survey'
		}
	});
};

const uploadBusinessCard = result => {
	const transferCacheValue = transferInputDataByConfig({ ...result });
	console.log('🚀 ~ uploadBusinessCard ~ transferCacheValue:', form.value, transferCacheValue);
	// 如果form.value 中的某些字段存在，这不需要覆盖
	const { userName, institutionName, occupation, phoneNumber, email, areaCode } = form.value;
	if (userName) {
		transferCacheValue.userName = userName;
	}
	if (institutionName) {
		transferCacheValue.institutionName = institutionName;
	}
	if (occupation) {
		transferCacheValue.occupation = occupation;
	}
	if (phoneNumber) {
		transferCacheValue.phoneNumber = phoneNumber;
		transferCacheValue.areaCode = areaCode;
	} else {
		// 如果原本存在手机号，则不更新区号，使用原本的区号
		syncAreaValue(result);
	}
	if (email) {
		transferCacheValue.email = email;
	}
	form.value = {
		...form.value,
		...transferCacheValue
	};
};

const inputCompany = ({ name }) => {
	forceUpdateFormData('institutionName', name);
};

// 承诺书签署
const switchAgree = () => {
	isAgree.value = !isAgree.value;
};

const setSignature = () => {
	if (!isAgree.value) {
		showDialog({
			dialog_affirm: true,
			dialog_text: '我已阅读并同意签署承诺书',
			dialog_cancel_text: '取消',
			dialog_confirm_text: '确定',
			dialog_confirm_btn: () => {
				sign();
				isAgree.value = true;
			}
		});
	} else {
		sign();
	}
};

const sign = () => {
	if (!signBase64.value) {
		rewriteSign();
	} else {
		showSign.value = true;
	}
};

const rewriteSign = () => {
	router.push({ name: 'attend_meeting_sign' });
};

const readPromise = url => {
	router.push({ name: 'attend_meeting_promise', query: { url: encodeURIComponent(url) } });
};

const { replaceModuleSubPath } = useNavigation();
const handleSubmit = debounce(async function () {
	if (disabled.value) return;

	const copiedForm = cloneDeep(form.value);
	if (copiedForm.attendanceCustomFiled) {
		copiedForm.attendanceCustomFiled = copiedForm.attendanceCustomFiled.map(item => {
			if ([1, 2].includes(item.type)) {
				let { dynamicFieldValue, conditionOptionVOList, ...rest } = item;
				if (dynamicFieldValue) {
					// 根据 dynamicFieldValue 拿到的下标集合，过滤 conditionOptionVOList
					const indexes = dynamicFieldValue
						.split(',')
						.filter(v => v !== '')
						.map(v => parseInt(v));
					conditionOptionVOList = (conditionOptionVOList || []).filter((_, idx) => indexes.includes(idx));
				} else {
					conditionOptionVOList = [];
				}
				return {
					...rest,
					conditionOptionVOList
				};
			}
			return item;
		});
	}

	const params = {
		...copiedForm,
		researchUserCustomFiled: copiedForm.attendanceCustomFiled,
		entourageInfoParamList: entouragePeople.value,
		areaCode: landAreaCode.value ? `+${landAreaCode.value}` : `+${DEFAULT_NUMBER_CODE}`
	};
	delete params.attendanceCustomFiled;

	// 取这一天的 10:00
	if (params.startTime && params.startTime !== 0) {
		params.startTime = dayjs(params.startTime).startOf('day').set('hour', 10).valueOf();
	}

	// 如果有登录就把用户id带过去 有了这个id才会记录历史随行人员数据
	const _u = getUserInfo();
	if (_u && _u.id) {
		params.comeinUserId = _u.id;
	}
	setInputValueCache(params);
	await appointment_applySurveyRecord.refresh({ id: baseInfo.value.id, params });
	sessionStorage.setItem('ENTOURAGE', '');

	replaceModuleSubPath('appointment', 'result');
});

const transferInputDataByConfig = inputData => {
	if (!inputData) return;
	const configToValueList = {
		'nameConfig': ['userName'],
		'phoneConfig': ['areaCode', 'phoneNumber'],
		'institutionConfig': ['institutionName'],
		'positionConfig': ['occupation'],
		'emailConfig': ['email'],
		'businessCardConfig': ['businessCard', 'cardInfo', 'cropBusinessCard', 'businessCardId']
	};
	const transferCacheValue = Object.entries(configToValueList).reduce((acc, [key, fields]) => {
		const baseInfoConfig = baseInfo.value[key];
		// 3:不展示, 只取开启了配置的字段
		if (!baseInfoConfig || baseInfoConfig === 3) return acc;

		const realData = fields.reduce((data, field) => {
			if (field in inputData) {
				data[field] = inputData[field];
			}
			return data;
		}, {});
		return { ...acc, ...realData };
	}, {});
	return transferCacheValue;
};

const updateFormFromCache = () => {
	const inputCache = getInputValueCache();
	const transferCacheValue = transferInputDataByConfig(inputCache);
	form.value = {
		...form.value,
		...transferCacheValue
	};
	syncAreaValue(form.value);
	const { businessCard } = inputCache || {};
	businessCard && businessCardUpload.value?.setDefaultCard(businessCard);
};

const getInputValueCache = () => {
	const id = storeId.value;
	const cacheKey = `SURVEY_APPLY_CACHE_${id}`;
	const cacheItemStr = localStorage.getItem(cacheKey);
	if (!cacheItemStr) return null;

	const cacheItem = JSON.parse(cacheItemStr);

	// 检查版本号是否一致
	if (cacheItem.version !== version.value) {
		console.log('版本号变更，清理缓存.');
		localStorage.removeItem(cacheKey);
		return null;
	}

	// 检查是否过期
	const now = new Date().getTime();
	const oneMonthMs = 30 * 24 * 60 * 60 * 1000; // 一个月的毫秒数
	if (now - cacheItem.createdAt > oneMonthMs) {
		console.log('输入缓存已过期, 将自动删除......');
		localStorage.removeItem(cacheKey);
		return null;
	}

	// 返回未过期的数据
	return cacheItem.data;
};

const setInputValueCache = data => {
	const cacheKeys = [
		'userName',
		'institutionName',
		'occupation',
		'areaCode',
		'phoneNumber',
		'email',
		'businessCard',
		'cropBusinessCard',
		'cardInfo'
	];
	const composeInputValue = cacheKeys.reduce((acc, key) => {
		if (data.hasOwnProperty(key)) {
			acc[key] = cloneDeep(data[key]);
		}
		return acc;
	}, {});

	const now = new Date().getTime();
	const cacheItem = {
		data: composeInputValue,
		createdAt: now,
		version: version.value
	};

	localStorage.setItem(`SURVEY_APPLY_CACHE_${storeId.value}`, JSON.stringify(cacheItem));
};

onMounted(async () => {
	// Clear
	sessionStorage.setItem('ENTOURAGE', '');

	// 判断是否为华为浏览器
	if (navigator.userAgent.indexOf('HuaweiBrowser') > -1) {
		isHuaweiBrowser.value = true;
	} else {
		isHuaweiBrowser.value = false;
	}

	await loadSurveyOption();
	updateFormFromCache();
});
</script>

<style lang="less" scoped>
@import '@/style/mixins.less';

.b-container {
	display: flex;
	flex-direction: column;
	height: 100%;
	background: #f6f7f8;

	.content {
		flex: 1;
		overflow-y: auto;
		padding: 0.1rem 0.14rem;
		.form-box {
			margin-bottom: 0.12rem;
			padding: 0 0.12rem;
			background: #fff;
			.item {
				padding: 0.14rem 0;
				display: flex;
				align-items: center;
				justify-items: center;
				font-size: 0.15rem;
				color: #333;
				&:not(:last-child) {
					border-bottom: 0.5px solid #e8eaef;
				}
				.label {
					flex-shrink: 0;
					width: 0.83rem;
				}
				.item-content {
					flex: 1;
					display: flex;
					justify-content: flex-end;
					align-items: center;
					line-height: 0.21rem;

					.icon-font {
						margin-left: 0.06rem;
					}
				}
				.item-value {
					max-width: 76%;
					color: #333;
					/* 15/H5-regular */
					font-family: 'PingFang SC';
					font-size: 0.15rem;
					font-style: normal;
					font-weight: 400;
					text-align: right;
					word-break: break-all;
				}
				.item-placeholder {
					color: #dcdcdc;
				}

				.common-flex {
					flex: 1;
					margin-left: 0.06rem;
					display: flex;
					align-items: center;
					text-align: right;
				}
				.area-input {
					display: flex;
					align-items: center;
					justify-content: flex-end;
					width: 0.9rem;
					font-size: 0;

					.area-code {
						color: #333;
						font-family: 'PingFang SC';
						font-size: 0.14rem;
						font-style: normal;
						font-weight: 400;
						line-height: 0.18rem; /* 128.571% */
					}
					.drop-popup {
						margin-left: 0.08rem;
						font-size: 0.1rem;
						color: #c5c5c5;
					}
					.area-separator {
						margin-left: 0.18rem;
						margin-right: 0.09rem;
						width: 0.01rem;
						height: 0.18rem;
						background: #e8eaef;
					}
				}
				.common-input {
					flex: 1;
					margin-left: 0.06rem;
					border: none;
					text-align: right;
					height: 0.21rem;
					line-height: 0.21rem;
				}
				.tip {
					font-size: 0.13rem;
					color: #999999;
					letter-spacing: 0.26px;
					line-height: 0.18rem;
				}
				.commitments {
					font-size: 0.13rem;
					color: var(--ir-theme-color);
					padding-left: 0.06rem;
					word-break: break-all;
				}
				.icon {
					margin-right: 0.02rem;
					font-size: 0.14rem;
					color: #989898;
				}
				.agree {
					color: var(--ir-theme-color);
				}
				.common-select-wrap {
					display: inline-block;
					margin-right: 0.01rem;
					vertical-align: -0.02rem;
				}
				.common-select {
					font-size: 0.18rem;

					&.common-selected {
						color: var(--ir-theme-color);
					}
				}
			}
			.upload-box {
				position: relative;
				padding: 0.16rem 0;
				display: flex;
				font-family: 'PingFang SC';
				.upload-title {
					color: #333;
					font-size: 0.16rem;
					font-weight: 500;
					line-height: 140%; /* 22.4px */
				}
				.upload-tip {
					padding-top: 0.07rem;
					color: #989898;
					font-size: 0.12rem;
					font-weight: 400;
					line-height: 140%; /* 16.8px */
				}
				.business-card-wrap {
					margin-left: 0.14rem;
				}
			}
		}
		.add-box {
			padding: 0.12rem 0 0.08rem;
			display: flex;
			justify-content: space-between;
			color: #666;
			font-weight: 500;
			line-height: 140%; /* 19.6px */
			.add-btn {
				display: flex;
				align-items: center;
				color: var(--ir-theme-color);

				.add-pre-icon {
					margin-right: 0.04rem;
					position: relative;
					font-size: 0.2rem;

					.pre-icon-white {
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						margin: auto;
						font-size: 0.4em;
						color: #fff;
					}
					.pre-icon-fill {
						font-size: 1em;
						color: var(--ir-theme-color);
					}
				}
			}
		}
	}
	.signature-preview {
		display: flex;
		align-items: center;
		height: 0.48rem;
		margin-left: 0.1rem;
		flex: 1;
		.signature-img {
			height: 100%;
		}
		.signature-text {
			color: var(--ir-theme-color);
		}
	}
	.pd0 {
		padding: 0 !important;
	}
	.ml6 {
		margin-left: 0.06rem;
	}
	.required {
		color: #eb5149;
		font-size: 0.15rem;
		font-weight: 400;
		vertical-align: middle;
	}
	.footer {
		bottom: 0;
		z-index: 2;
		padding: 0.2rem 0.14rem;

		@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
			padding-bottom: calc(constant(safe-area-inset-bottom) + 0.2rem);
			padding-bottom: calc(env(safe-area-inset-bottom) + 0.2rem);
		}
		background-color: #fff;
		box-shadow: 0px -2.5px 6.5px 0px #00000005;
		transform: translateZ(0);
		-webkit-transform: translateZ(0);
		&.HuaweiBrowser {
			height: 0.98rem;
			box-sizing: content-box;
		}

		.btn {
			background-color: var(--ir-theme-color);
			height: 0.42rem;
			line-height: 0.42rem;
			font-size: 0.17rem;
		}

		.disabled {
			background: var(--ir-theme-color-opacity-2);
		}
	}

	.c-search {
		/deep/.picker-list {
			top: 186% !important;
		}
		/deep/.text-area {
			min-height: 0.21rem;
			line-height: 0.21rem;
		}
	}

	/deep/ .search-picker {
		.text-area::placeholder {
			color: #dcdcdc;
		}
	}

	.clear-van-field {
		flex: 1;
		width: 0;
		border: none;
		height: 0.21rem;
		padding: 0;

		/deep/ .van-field__control {
			text-align: right;
			font-size: 0.15rem;
			color: #333;
			line-height: 0.21rem;

			&::placeholder,
			&::-webkit-input-placeholder {
				color: #dcdcdc;
			}
		}
	}
}
</style>
